import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
export const resolveGiveawaysEndpoint = {
    [giveawayEndpointIds.GIVEAWAYS_RESOLVE]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
